import axios from "axios";
import crudApi from "./crudApi";
import {API_HISTORIES} from '../api.js';

class History extends crudApi {
    get(id,options = {}) {
        return axios.get(`${API_HISTORIES}/${id}`, options);
    }
};
export default new History(API_HISTORIES);
